// Textos de las pestañas de la ficha de usuario del backoffice (user-detail-tabs). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'es',
  data: {
    USER_DETAIL_TABS: {
      ROUTES: {
        VIEW_FRAUD_TAB: 'Con señales de fraude',
        SIGNAL_TRIPS_NONE_SENTENCE: 'Ningún viaje con señales.',
        DECISION_IN_FRAUD: 'La decisión se toma en Fraude.',
        SHOWING: 'Mostrando {{count}} de {{total}} viajes',
        SHOWING_FRAUD: 'Mostrando {{count}} de {{total}} viajes con señales (los más sospechosos)',
        TITLE: 'Viajes',
        SUBTITLE:
          'Trayectos del usuario como conductor o pasajero. Haz clic en uno para ver quién iba en el coche; con la flecha › abres el viaje.',
        RELOAD: 'Recargar',
        SEARCH_PLACEHOLDER: 'Buscar por rutina…',
        SEARCH_ARIA: 'Buscar por rutina',
        ROLE_ARIA: 'Rol',
        ROLE_ALL: 'Rol: todos',
        ROLE_DRIVER: 'Conductor',
        ROLE_RIDER: 'Pasajero',
        UNVERIFIED_IDENTITY: 'Sin identidad verificada',
        UNVERIFIED_IDENTITY_HINT: 'Hizo este viaje sin la identidad verificada',
        ALL: 'Todos',
        STATUS_ARIA: 'Estado del viaje',
        STATUS_ALL: 'Estado: todos',
        FOOTPRINT_ARIA: 'Huella',
        FOOTPRINT_DEFAULT: 'Huella: todas',
        FOOTPRINT_VERIFIED: 'Verificada',
        FOOTPRINT_REJECTED: 'Rechazada',
        FOOTPRINT_PENDING: 'Pendiente',
        FOOTPRINT_DECIDED: 'Verificada o rechazada',
        FOOTPRINT_FACE_HOLD: 'Retenida',
        FOOTPRINT_FACE_HOLD_HINT: 'Retenida por la verificación facial hasta el {{date}}. Hasta entonces no se verifica la huella.',
        FOOTPRINT_FACE_HOLD_HINT_NO_DATE: 'Retenida por la verificación facial. La fecha de liberación se fija en la primera pasada de la verificación.',
        FOOTPRINT_APP_VERIFYING: "En la app: «Verificando»",
        FOOTPRINT_VERIFYING_HINT: "Verificada, pero el conductor aún no ha cobrado (abono aplazado por retraso de caja o por verificación reforzada). Hasta que cobre, la app muestra «Verificando».",
        NO_FOOTPRINT: 'Sin huella',
        FROM: 'Desde',
        TO: 'Hasta',
        CLEAR_FILTERS: 'Limpiar filtros',
        LOADING: 'Cargando viajes…',
        RETRY: 'Reintentar',
        EMPTY_FILTERED: 'Ningún viaje coincide con los filtros.',
        EMPTY: 'Este usuario no tiene viajes.',
        TH_DATE: 'Fecha',
        TH_ROUTE: 'Trayecto',
        TH_ROLE: 'Rol',
        CAR_SHOW: 'Ver quién iba en el coche',
        CAR_HIDE: 'Ocultar el coche',
        CAR_LOADING: 'Cargando el coche…',
        CAR_ERROR: 'No se ha podido cargar quién iba en el coche.',
        CAR_PICKUP_ORDER: 'recogida n.º {{n}}',
        CAR_PEOPLE_ONE: '{{n}} persona',
        CAR_PEOPLE_MANY: '{{n}} personas',
        CAR_TITLE: 'En el coche',
        CAR_PAYS: 'Paga',
        CAR_EARNS: 'Cobra',
        CAR_THIS_USER: 'Este usuario',
        TH_ROUTINE: 'Rutina',
        TH_STATUS: 'Estado',
        TH_FOOTPRINT: 'Huella',
        OPEN: 'Abrir',
        VIEW_TRIP: 'Ver viaje',
        PAGE: 'Página',
        OF: 'de',
        PREV_PAGE: 'Página anterior',
        NEXT_PAGE: 'Página siguiente',
        OPT_PENDING: 'Pendiente',
        OPT_IN_PROGRESS: 'En progreso',
        OPT_COMPLETED: 'Completada',
        OPT_CANCELLED: 'Cancelada',
        OPT_VERIFIED: 'Verificada',
        STATUS_PENDING: 'Pendiente',
        STATUS_IN_PROGRESS: 'En curso',
        STATUS_COMPLETED: 'Completado',
        STATUS_CANCELLED: 'Cancelado',
        STATUS_VERIFIED: 'Verificado',
        STATUS_REJECTED: 'Rechazado',
        STATUS_DELETED: 'Borrado',
        STATUS_DELETED_F: 'Borrada',
        SEATS_OCCUPANTS: '{{n}} ocupantes',
        SEATS: '{{current}}/{{available}} plazas',
        ERROR_LOAD: 'No se ha podido cargar el listado de viajes del usuario.',
        PAGINATION: '{{from}}-{{to}} de {{total}}',
        FRAUD_TITLE: 'Fraude:',
        SCORE: 'Score',
        SIGNAL_TRIPS_NONE: 'ningún viaje con señales',
        SIGNAL_TRIPS_ONE: '{{n}} viaje con señales',
        SIGNAL_TRIPS_MANY: '{{n}} viajes con señales',
        MANAGE_FRAUD: 'Gestionar en Fraude',
        VIEW_ARIA: 'Viajes a mostrar',
        VIEW_ALL: 'Todos los viajes',
        VIEW_FRAUD: 'Con señales de fraude ({{n}})',
        TH_PASSENGERS: 'Pasajeros',
        TH_SIGNALS: 'Señales',
        TH_MONEY: 'Dinero',
        TH_MODE: 'Modalidad',
        TH_FRAUD: 'Fraude',
        DRIVER_COLON: 'Conductor:',
        NO_MATCH: 'Sin match',
        NO_PRICE: 'Sin precio',
        FREE_TRIP: 'Viaje gratis',
        UNTIL: 'hasta {{date}}',
        SHOWING_MOST: 'Se muestran los {{shown}} más sospechosos de {{total}}.',
        LOW_SIGNALS: 'Señales bajas',
        ERROR_FRAUD: 'No se ha podido cargar la información de fraude.',
        COLLUSION_PAIRS_TITLE: 'Colusión por pareja',
        COLLUSION_PAIRS_TEXT: 'Con quién no parece una persona independiente, según el equipo de datos. Más alto = peor.',
        TH_PERSON: 'Persona',
        TH_COLLUSION: 'Colusión',
        TH_TRIPS_TOGETHER: 'Viajes juntos',
        TH_LAST_VALUE: 'Último valor',
        TH_HISTORY: 'Historial',
        HISTORY_SHOW: 'Historial ({{n}})',
        HISTORY_HIDE: 'Ocultar historial',
        TRIPS_TOGETHER_N: '{{n}} viajes juntos',
        PAYOUT_PAID: 'Pagado',
        PAYOUT_HELD: 'Retenido',
        PAYOUT_UNPAID: 'Sin cobrar',
        FRAUD_BLACKLIST: 'Lista negra',
        FRAUD_WHITELIST: 'Lista blanca',
        FRAUD_REINFORCED_NOCOST: 'Reforzada + sin coste 0',
        FRAUD_REINFORCED: 'Verificación reforzada',
        FRAUD_NOCOST: 'Sin coste 0',
        FRAUD_ALLOW: 'No fraude',
        FRAUD_NONE: 'Sin decisión',
        SIG_GPS: 'GPS',
        SIG_COLLISION: "Colusión",
        SIG_COPRESENCE: 'Co-presencia',
        SIG_NETWORK: 'Red/IP',
        SIG_TRANSPORT: 'Transporte',
      },
      MOVEMENTS: {
        SHOWING: 'Mostrando <b>{{count}}</b> de <b>{{total}}</b> movimientos',
        TITLE: 'Movimientos del wallet',
        SUBTITLE:
          'Los cobros de un mismo viaje se agrupan en una fila; despliégala para ver cuánto pagó cada pasajero.',
        RELOAD: 'Recargar',
        NOT_GROUPED:
          'El backend de este entorno aún no agrupa los cobros por viaje: se muestran uno a uno.',
        LOADING: 'Cargando movimientos…',
        RETRY: 'Reintentar',
        EMPTY: 'Este usuario no tiene movimientos en su wallet.',
        EXPAND: 'Desplegar',
        TH_DATE: 'Fecha',
        TH_TYPE: 'Tipo',
        TH_CONCEPT: 'Concepto',
        TH_AMOUNT: 'Importe',
        TH_BALANCE: 'Saldo tras movimiento',
        NO_NAME: 'Pasajero sin nombre',
        BALANCE: 'Saldo',
        PAGE: 'Página',
        OF: 'de',
        PREV_PAGE: 'Página anterior',
        NEXT_PAGE: 'Página siguiente',
        PAGINATION: '{{from}}–{{to}} de {{total}}',
        ERROR_LOAD:
          'No se han podido cargar los movimientos del wallet del usuario.',
        TYPES: {
          withdrawal: 'Retirada',
          instant_withdrawal: 'Retirada instantánea',
          instant_payout_fee: 'Comisión retirada instantánea',
          instant_payout_refund: 'Devolución retirada instantánea',
          income: 'Ingreso',
          waiis_commission: 'Comisión WAIIS',
          trip_income: 'Ingreso por trayecto',
          trip_payment: 'Pago de trayecto',
          saas_commission: 'Comisión suscripción SaaS',
          manual_income: 'Ingreso manual',
          manual_withdrawal: 'Retirada manual',
          other: 'Otro',
        },
        CONCEPT: {
          TRIP_GROUPED_ONE: 'Viaje compartido · {{count}} pasajero',
          TRIP_GROUPED_OTHER: 'Viaje compartido · {{count}} pasajeros',
          withdrawal: 'Retirada #{{id}}',
          instant_withdrawal: 'Retirada instantánea #{{id}}',
          instant_payout_fee: 'Comisión retirada instantánea · transferencia #{{id}}',
          instant_payout_refund: 'Devolución de retirada instantánea',
          income: 'Ingreso #{{id}}',
          waiis_commission: 'Comisión WAIIS · transferencia #{{id}}',
          trip_income: 'Ingreso por trayecto · transferencia #{{id}}',
          saas_commission: 'Comisión suscripción SaaS · transferencia #{{id}}',
          trip_payment: 'Pago de trayecto',
          other: 'Otro movimiento',
        },
      },
      DEPOSIT: {
        SAVING: 'Guardando…',
        ERROR_SAVE_TITLE: 'No se ha podido guardar el movimiento',
        TITLE: 'Nuevo movimiento en el wallet',
        SUBTITLE:
          'Ingresa o retira saldo manualmente. El usuario verá el motivo en sus movimientos.',
        KIND_ARIA: 'Tipo de movimiento',
        KIND_DEPOSIT: 'Ingreso',
        KIND_DEPOSIT_HINT: 'Añade saldo al usuario',
        KIND_WITHDRAW: 'Retirada',
        KIND_WITHDRAW_HINT: 'Descuenta saldo del usuario',
        AMOUNT: 'Importe',
        REASON: 'Motivo',
        REASON_PLACEHOLDER: 'Explica por qué se hace el movimiento',
        REASON_1: 'Compensación por incidencia en un viaje',
        REASON_2: 'Devolución de un cobro duplicado',
        REASON_3: 'Bonificación promocional',
        REASON_4: 'Corrección de saldo',
        PROCESSING: 'Procesando…',
        ACTION_WITHDRAW: 'Retirar saldo',
        ACTION_DEPOSIT: 'Ingresar saldo',
        PREVIEW_ARIA: 'Vista previa del saldo',
        SUMMARY: 'Resumen',
        CURRENT_BALANCE: 'Saldo actual',
        NOT_AVAILABLE: 'No disponible',
        BALANCE_AFTER: 'Saldo tras el movimiento',
        EXCEEDS: 'La retirada supera el saldo del usuario.',
        LOGGED_WITHDRAW:
          'Queda registrado como «Retirada manual» en la pestaña Movimientos.',
        LOGGED_DEPOSIT:
          'Queda registrado como «Ingreso manual» en la pestaña Movimientos.',
        OK: 'OK',
        ERROR_TITLE: 'Error',
        SUCCESS_WITHDRAW_TITLE: 'Retirada realizada',
        SUCCESS_DEPOSIT_TITLE: 'Ingreso realizado',
        SUCCESS_WITHDRAW_TEXT:
          'El importe se ha retirado correctamente del wallet del usuario.',
        SUCCESS_DEPOSIT_TEXT:
          'El importe se ha añadido correctamente al wallet del usuario.',
        ERROR_MOVEMENT:
          'No se ha podido realizar el movimiento en el wallet del usuario.',
        ERR_REQUIRED: 'Este campo es obligatorio',
        ERR_POSITIVE: 'Introduce un importe mayor que 0',
        ERR_MAXLENGTH: 'El motivo no puede superar los 255 caracteres',
        ERR_INVALID: 'Campo inválido',
        TITLE_CREDITS: 'Nuevo movimiento de créditos',
        SUBTITLE_CREDITS: 'Suma o quita créditos de la app. El usuario verá «Ingreso manual» o «Retirada manual» en su historial de créditos; el motivo queda solo para el equipo.',
        TARGET_ARIA: 'Qué quieres mover',
        TARGET_WALLET: 'Saldo (€)',
        TARGET_CREDITS: 'Créditos',
        KIND_DEPOSIT_HINT_CREDITS: 'Añade créditos al usuario',
        KIND_WITHDRAW_HINT_CREDITS: 'Quita créditos al usuario',
        AMOUNT_CREDITS: 'Créditos',
        SUFFIX_CREDITS: 'cr.',
        ERR_INTEGER: 'Los créditos tienen que ser un número entero',
        CURRENT_CREDITS: 'Créditos actuales',
        CREDITS_AFTER: 'Créditos tras el movimiento',
        EXCEEDS_CREDITS: 'La retirada supera los créditos del usuario.',
        LOGGED_WITHDRAW_CREDITS: 'Queda registrado como «Retirada manual» en la pestaña Movimientos (créditos).',
        LOGGED_DEPOSIT_CREDITS: 'Queda registrado como «Ingreso manual» en la pestaña Movimientos (créditos).',
        ACTION_WITHDRAW_CREDITS: 'Retirar créditos',
        ACTION_DEPOSIT_CREDITS: 'Ingresar créditos',
        CREDIT_ONE: 'crédito',
        CREDIT_MANY: 'créditos',
        SUCCESS_WITHDRAW_TEXT_CREDITS: 'El importe se ha retirado correctamente de los créditos del usuario.',
        SUCCESS_DEPOSIT_TEXT_CREDITS: 'El importe se ha añadido correctamente a los créditos del usuario.',
      },
      CREDITS: {
        SHOWING: 'Mostrando <b>{{count}}</b> de <b>{{total}}</b> movimientos',
        TITLE: 'Movimientos de créditos',
        SUBTITLE: 'Créditos de la app (bonus, incentivos, cupones y ajustes manuales).',
        CURRENT_BALANCE: 'Saldo actual',
        CREDITS_LOWER: 'créditos',
        RELOAD: 'Recargar',
        LOADING: 'Cargando créditos…',
        RETRY: 'Reintentar',
        EMPTY: 'Este usuario no tiene movimientos de créditos.',
        TH_DATE: 'Fecha',
        TH_TYPE: 'Tipo',
        TH_REASON: 'Motivo',
        TH_CREDITS: 'Créditos',
        TH_BALANCE: 'Saldo tras movimiento',
        NO_TYPE: 'Sin tipo',
        BY: 'por {{name}}',
        PAGE: 'Página',
        OF: 'de',
        PREV_PAGE: 'Página anterior',
        NEXT_PAGE: 'Página siguiente',
        ERROR_LOAD: 'No se han podido cargar los créditos del usuario.',
        TYPES: {
          VERIFY_ROUTINE: 'Verificación de rutina',
          CREATE_ROUTINE: 'Creación de rutina',
          TRIP_PAYMENT: 'Pago de viaje con créditos',
          TRIP_BONUS: 'Bonus por viaje finalizado',
          RIDER_FINISHED_TRIP: 'Viaje de pasajero finalizado',
          COUPON_EXCHANGE: 'Cupón canjeado',
          SUBSIDY_REFUND: 'Reembolso de subvención corporativa',
          INCENTIVE_VERIFY_DNI: 'Bono de bienvenida · verificación de DNI',
          INCENTIVE_NO_TRIPS: 'Bono primer viaje',
          INCENTIVE_INACTIVE: 'Bono de reactivación',
          MANUAL_CREDIT_INCOME: 'Ingreso manual de créditos',
          MANUAL_CREDIT_WITHDRAWAL: 'Retirada manual de créditos',
        },
      },
    },
  },
};
